module.exports = __webpack_public_path__ + "static/media/my-account-bg.b5a0d11d.jpg";